import { endpoints, request } from '!core/api';

export const publicOfferServices = {
  publicOffer: ({ account }) =>
    request.get(
      endpoints.backoffice(`WsbGetPublicOffer?account=${account}&historic=N`),
    ),
  publicOfferHistorical: ({ account }) =>
    request.get(
      endpoints.backoffice(`WsbGetPublicOffer?account=${account}&historic=Y`),
    ),
  publicOfferAll: ({ account }) =>
    request.get(
      endpoints.backoffice(`WsbGetPublicOffer?account=${account}&historic=T`),
    ),
};
